import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home.vue'
import Select from '@/pages/Select.vue'
import Articles from '@/pages/Articles.vue'
import MadeFor from '@/pages/MadeFor.vue'
import Contest from '@/pages/Contest.vue'
import Form from '@/pages/Form.vue'

import Article1 from '@/pages/Article1.vue'
import Article2 from '@/pages/Article2.vue'
import Article3 from '@/pages/Article3.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/select',
			name: 'select',
			component: Select
		},
		{
			path: '/articles',
			name: 'articles',
			component: Articles
		},
		{
			path: '/madefor',
			name: 'madefor',
			component: MadeFor
		},
		{
			path: '/contest',
			name: 'contest',
			component: Contest
		},
		{
			path: '/form',
			name: 'form',
			component: Form
		},
		{
			path: '/tatu-culture',
			name: 'article1',
			component: Article1
		},
		{
			path: '/lichni-opit',
			name: 'article2',
			component: Article2
		},
		{
			path: '/trendi-v-industrii',
			name: 'article3',
			component: Article3
		},
	]
})